var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.57881,
    cy: 6.27803,
    r: 4.77803,
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00002 17.7013C0.998732 17.3654 1.07385 17.0336 1.2197 16.7311C1.67736 15.8157 2.96798 15.3306 4.03892 15.1109C4.81128 14.9461 5.59431 14.836 6.38217 14.7814C7.84084 14.6533 9.30793 14.6533 10.7666 14.7814C11.5544 14.8366 12.3374 14.9467 13.1099 15.1109C14.1808 15.3306 15.4714 15.77 15.9291 16.7311C16.2224 17.3479 16.2224 18.0639 15.9291 18.6807C15.4714 19.6418 14.1808 20.0812 13.1099 20.2917C12.3384 20.4633 11.5551 20.5766 10.7666 20.6304C9.57937 20.731 8.38659 20.7494 7.19681 20.6853C6.92221 20.6853 6.65677 20.6853 6.38217 20.6304C5.59663 20.5772 4.81632 20.464 4.04807 20.2917C2.96798 20.0812 1.68652 19.6418 1.2197 18.6807C1.0746 18.3746 0.999552 18.04 1.00002 17.7013Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.6c49f5aa714ef29a10a65202d1a398d5.svg";
export { ForwardRef as ReactComponent };